import { ApiService, ConfigService } from '../../../shared/services';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { MobileUserSettings, PersonalInfo, DetailedResponse, UpdatePasswordModel } from '../models';

@Injectable()
export class SettingsService {
    _baseUrl: string = this._configService.getContext('management').url;

    constructor(private _configService: ConfigService,
                private _apiService: ApiService,
                ) { }

    getUserSettings(): Observable<MobileUserSettings> {
        return this._apiService.get(this._baseUrl, 'users/me/mobile/settings')
        .do(res => { return new MobileUserSettings(res); })
        .cache();
    }

    setUserSettings(payload: PersonalInfo): Observable<DetailedResponse> {
        return this._apiService.post(this._baseUrl, 'users/mobile/settings', payload)
        .map(res => res)
        .cache();
    }

     setUserPassword(payload: UpdatePasswordModel): Observable<DetailedResponse> {
        return this._apiService.post(this._baseUrl, 'users/password', payload)
        .map(res => res)
        .cache();
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/settings/shared/services/settings.service.ts